// ----------------------------------------------------------------------

const shape = {
  borderRadius: 8,
  borderRadiusMd: 16,
  borderRadiusSm: 12,
};

export default shape;
